var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import fetch from 'node-fetch';
var Auth = /** @class */ (function () {
    /**
     *
     * @param config
     * @param redirect
     */
    function Auth(config, redirect) {
        if (redirect === void 0) { redirect = ''; }
        var _this = this;
        /**
         *
         * @param responsemode
         * @returns string
         */
        this.createLoginString = function (responsemode) {
            if (responsemode === void 0) { responsemode = 'query'; }
            return "".concat(_this.config['auth-server-url'], "realms/").concat(_this.config.realm, "/protocol/openid-connect/auth?client_id=").concat(_this.config.resource).concat(_this.redirect !== '' ? "&redirect_uri=".concat(_this.redirect) : '', "&response_mode=").concat(responsemode, "&response_type=code&scope=web-origins");
        };
        /**
         *
         * @param responsemode
         * @returns string
         */
        this.createRegistrationString = function (responsemode) {
            if (responsemode === void 0) { responsemode = 'query'; }
            return "".concat(_this.config['auth-server-url'], "realms/").concat(_this.config.realm, "/protocol/openid-connect/registrations?client_id=").concat(_this.config.resource).concat(_this.redirect !== '' ? "&redirect_uri=".concat(_this.redirect) : '', "&response_mode=").concat(responsemode, "&response_type=code&scope=web-origins");
        };
        /**
         *
         * @param code code from response or refresh_token for renew an access_token
         * @param refresh If true, a call is made to get a new access_token. If False uses the code to get an access_token ( default: false)
         * @returns KeycloakTokenResponse
         */
        this.getToken = function (code, refresh) {
            if (refresh === void 0) { refresh = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var formData, response, dataJson, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            formData = new URLSearchParams();
                            if (refresh) {
                                formData.append('grant_type', 'refresh_token');
                            }
                            else {
                                formData.append('grant_type', 'authorization_code');
                            }
                            formData.append('client_id', this.config.resource);
                            if (typeof this.config.credentials !== 'undefined') {
                                formData.append('client_secret', this.config.credentials.secret);
                            }
                            if (refresh) {
                                formData.append('refresh_token', code);
                            }
                            else {
                                formData.append('code', code);
                            }
                            formData.append('redirect_uri', this.redirect);
                            return [4 /*yield*/, fetch(this.getTokenUrl, {
                                    method: 'POST',
                                    headers: this.headers,
                                    body: formData.toString(),
                                })];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            dataJson = _a.sent();
                            data = dataJson;
                            return [2 /*return*/, data];
                    }
                });
            });
        };
        /**
         *
         * @param refreshtoken
         * @returns boolean
         */
        this.logout = function (refreshtoken) { return __awaiter(_this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new URLSearchParams();
                        formData.append('refresh_token', refreshtoken);
                        formData.append('client_id', this.config.resource);
                        if (typeof this.config.credentials !== 'undefined') {
                            formData.append('client_secret', this.config.credentials.secret);
                        }
                        return [4 /*yield*/, fetch(this.getLogoutUrl, {
                                method: 'POST',
                                body: formData.toString(),
                                headers: this.headers,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        }); };
        this.config = config;
        this.redirect = redirect;
        this.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };
        this.getTokenUrl = "".concat(this.config['auth-server-url'], "realms/").concat(this.config.realm, "/protocol/openid-connect/token");
        this.getUserinfoUrl = "".concat(this.config['auth-server-url'], "realms/").concat(this.config.realm, "/protocol/openid-connect/userinfo");
        this.getLogoutUrl = "".concat(this.config['auth-server-url'], "realms/").concat(this.config.realm, "/protocol/openid-connect/logout");
    }
    return Auth;
}());
export default Auth;
